/*eslint-disable */
import { bus } from '@/main';
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
export default {
  name: 'add-rlist-user',
  components: {},
  props: ['updateInfoOfUserID'],
  data () {
    return {
      userData: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: ''
      },
      signupactiveStatus:true,
      loginactiveStatus:true,
      paymentactiveStatus:true,
      signupactiveVal:'signup',
      loginactiveVal:'login',
      paymentactiveVal:'payment',
      submitted:false
    }
  },
  computed: {
    isEmailRequired() {
      if (this.userData.mobile === '')
      if (this.userData.first_name === '')
      if (this.userData.last_name === '')
      return true; // email is required
      return false;
    },
  },
  mounted () {
    if(this.updateInfoOfUserID){
      this.getUserDetail(this.updateInfoOfUserID)
    }
  },
  methods: {
    getUserDetail(userId) {
      this.$store.dispatch('getRListUserListDetailsById', {
        id: userId
      }).then((res) => {
        this.userData = res.data.data;
        if(this.userData.restrictions.includes("signup")){
          this.signupactiveStatus = true
          this.signupactiveVal = 'signup'
        }else{
          this.signupactiveStatus = false
          this.signupactiveVal = ''
        } if(this.userData.restrictions.includes("login")){
          this.loginactiveStatus = true
          this.loginactiveVal = 'login'
        }else{
          this.loginactiveStatus = false
          this.loginactiveVal = ''
        } if(this.userData.restrictions.includes("payment")){
          this.paymentactiveStatus = true
          this.paymentactiveVal = 'payment'
        }else{
          this.paymentactiveStatus = false
          this.paymentactiveVal = ''
        }
      }).catch((err) => {})
    },
    getUserListAgain() {
      this.$store.dispatch('getRListUsersFun')
    },
    signupactiveStatusFun(){
      if(this.signupactiveStatus == true){
        this.signupactiveStatus= false
        this.signupactiveVal = ''
      }else{
        this.signupactiveVal = 'signup'
        this.signupactiveStatus= true
      }
    },
    loginactiveStatusFun(){
      if(this.loginactiveStatus == true){
        this.loginactiveStatus= false
        this.loginactiveVal = ''
      }else{
        this.loginactiveVal = 'login'
        this.loginactiveStatus= true
      }
    },
    paymentupactiveStatusFun(){
      if(this.paymentactiveStatus == true){
        this.paymentactiveVal = ''
        this.paymentactiveStatus= false
      }else{
        this.paymentactiveVal = 'payment'
        this.paymentactiveStatus= true
      }
    },
    validateAddUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.updateInfoOfUserID){
            this.submitted = true;
            // console.log(this.updateInfoOfUserID, "Cehckinf")
            let data = {
              restrictions:[]
            }
            if(this.signupactiveVal != null && this.signupactiveVal != ''){
              data.restrictions.push(this.signupactiveVal);
            }
            if(this.loginactiveVal != null && this.loginactiveVal != ''){
              data.restrictions.push(this.loginactiveVal);
            }
            if(this.paymentactiveVal != null && this.paymentactiveVal != ''){
              data.restrictions.push(this.paymentactiveVal);
            }
            if(this.userData.first_name != null && this.userData.first_name != ''){
              data.first_name = this.userData.first_name;
            }
            if(this.userData.last_name != null && this.userData.last_name != ''){
              data.last_name = this.userData.last_name;
            }
            if(this.userData.email != null && this.userData.email != ''){
              data.email = this.userData.email;
            }
            if(this.userData.mobile != null && this.userData.mobile != ''){
              data.mobile = this.userData.mobile;
            }
            this.$store.dispatch('UpdateRListUserDetailsById', {data:{
              id:this.updateInfoOfUserID,data:data}}).then((res) => {
                toast.success(res.data.msg);
                this.getUserListAgain()
                this.closeCreateMeetingPopup()
                this.$validator.reset();
            }).catch((err) => {})
            return;
          }else{
            this.submitted = true;
            let data = {
              restrictions:[]
            }
            if(this.signupactiveVal != null && this.signupactiveVal != ''){
              data.restrictions.push(this.signupactiveVal);
            }
            if(this.loginactiveVal != null && this.loginactiveVal != ''){
              data.restrictions.push(this.loginactiveVal);
            }
            if(this.paymentactiveVal != null && this.paymentactiveVal != ''){
              data.restrictions.push(this.paymentactiveVal);
            }
            if(this.userData.first_name != null && this.userData.first_name != ''){
              data.first_name = this.userData.first_name;
            }
            if(this.userData.last_name != null && this.userData.last_name != ''){
              data.last_name = this.userData.last_name;
            }
            if(this.userData.email != null && this.userData.email != ''){
              data.email = this.userData.email;
            }
            if(this.userData.mobile != null && this.userData.mobile != ''){
              data.mobile = this.userData.mobile;
            }
            this.$store.dispatch('addNewRListUserFun', data).then((res) => {
                toast.success(res.data.msg);
                this.getUserListAgain()
                this.closeCreateMeetingPopup()
                this.$validator.reset();
            }).catch((err) => {
              toast.error(err.data.data.non_field_errors || err.data.data.email || err.data);
            })
            return;
          }
        }
      });
    },
    closeCreateMeetingPopup() {
      bus.$emit('HideAddUserPopup', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}


